import { useTranslation } from '@mint-lib/i18n';
import { WarningAltFilled } from '@mint-lib/icons';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

type ConfirmChangeGranularityLevelDialogProps = {
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
};

export const ConfirmChangeGranularityLevelDialog = ({
  onClose,
  onSubmit,
  isSubmitting,
}: ConfirmChangeGranularityLevelDialogProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={handleOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s">
          <DialogHeader>
            <DialogTitle className="flex flex-row items-center justify-center gap-2">
              <WarningAltFilled className="size-5 fill-warning-main" />
              <p>{t('Change data attribution level?')}</p>
            </DialogTitle>
          </DialogHeader>
          <DialogContent>
            <DialogDescription>
              {t(
                'Switching the data attribution level will reset your mapped ARM items due to different item requirements at each level. Do you want to continue?',
              )}
            </DialogDescription>
          </DialogContent>
          <DialogFooter>
            <Button
              data-dd-action-name="Granularity level change: cancel"
              size="large"
              variant="text"
              onClick={onClose}
            >
              {t('Cancel')}
            </Button>
            <Button
              data-dd-action-name="Granularity level change: confirm"
              size="large"
              color="warning"
              onClick={onSubmit}
              disabled={isSubmitting}
            >
              {t('Yes, change')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};
